<div class="radio-group__item" *ngFor="let bv of fp.bvs">
  <div class="radio">
    <input type="radio" [name]="fp.id" [id]="fp.id+'/'+bv.id" [(ngModel)]="value" [value]="bv.id">
    <label class="radio__label" [for]="fp.id+'/'+bv.id">{{ cameleonService.getBVDescription(bv) }}</label>
  </div>
</div>
